import { useMemo } from "react";
import { useAuthContext } from "../../../../context/AuthContext";
import PaxtonDoorsView from "./PaxtonDoorsView";

function PaxtonDoors({ configData, setConfigData, paxtonResources }) {
  const authContext = useAuthContext();

  const doorLabels = useMemo(() => {
    return paxtonResources.doors.reduce((labels, door) => {
      labels[door.id] = door.name;
      return labels;
    }, {});
  }, [paxtonResources.doors]);

  const availableDoors = useMemo(() => {
    return paxtonResources.doors.filter((door) => {
      return !configData.doors.some(
        (configDoor) => configDoor.door_id === door.id,
      );
    });
  }, [paxtonResources.doors, configData]);

  /**
   * This method will add a door to the config data
   * @param {int} doorId
   */
  function onDoorAdd(doorId) {
    setConfigData((prev) => ({
      ...prev,
      doors: [
        ...prev.doors,
        {
          door_id: doorId,
          location_id: authContext.auth?.user?.company?.locations?.[0]?.id,
        },
      ],
    }));
  }

  /**
   * This method will update a door's property in the config data
   * @param {int} doorId
   * @param {string} key
   * @param {*} value
   */
  function onDoorChange(doorId, key, value) {
    setConfigData((prev) => ({
      ...prev,
      doors: prev.doors.map((door) =>
        door.door_id === doorId ? { ...door, [key]: value } : door,
      ),
    }));
  }

  /**
   * This method will delete a door from the config data
   * @param {int} doorId
   */
  function onDoorDelete(doorId) {
    setConfigData((prev) => ({
      ...prev,
      doors: prev.doors.filter((door) => door.door_id !== doorId),
    }));
  }

  return (
    <PaxtonDoorsView
      availableDoors={availableDoors}
      doorLabels={doorLabels}
      configData={configData}
      onDoorAdd={onDoorAdd}
      onDoorChange={onDoorChange}
      onDoorDelete={onDoorDelete}
    />
  );
}

export default PaxtonDoors;
